<template>
    <div class="w-full flex gap-x-4">
        <Select :disableClear="true" label="Mês" placeholder="Selecionar o mês" :list="months" desc="descricao" v-model="month" @filter="changeDate()" :disabled="_disabled"/>
        <Select :disableClear="true" label="Ano" placeholder="Selecionar o ano" :list="years" desc="descricao" v-model="year" @filter="changeDate()" :disabled="_disabled"/>
    </div>
    <!-- <Select /> -->
</template>

<script>
import { ref } from '@vue/reactivity'
import Select from './Select.vue'
import { computed } from '@vue/runtime-core'
export default {
    components: { Select },
    props: ['modelValue', 'disabled'],
    setup (props, { emit }) {
        const month = ref('')
        const year = ref('')
        const months = [
            { id: 0, descricao: 'Janeiro' },
            { id: 1, descricao: 'Fevereiro' },
            { id: 2, descricao: 'Março' },
            { id: 3, descricao: 'Abril' },
            { id: 4, descricao: 'Maio' },
            { id: 5, descricao: 'Junho' },
            { id: 6, descricao: 'Julho' },
            { id: 7, descricao: 'Agosto' },
            { id: 8, descricao: 'Setembro' },
            { id: 9, descricao: 'Outubro' },
            { id: 10, descricao: 'Novembro' },
            { id: 11, descricao: 'Dezembro' }
        ]
        const date = new Date()

        const years = ref([])
        for (let i = 2010; i <= date.getFullYear(); i++) {
            years.value.push({ id: i, descricao: i.toString() })
        }

        years.value.reverse()

        if (props.modelValue !== '') {
            
            month.value = months[props.modelValue.slice(-2) - 1].descricao
            year.value = props.modelValue.slice(0, 4)
        }
        const _disabled = computed(() => {
            return props.disabled
        })

        const value = computed({
            get: () => { props.modelValue },
            set: (vl) => emit('update:modelValue', vl)
        })

        const changeDate = () => {
            value.value = year.value + ((months.filter(m => m.descricao === month.value)[0].id + 1 > 9 ? '' : '0') + (months.filter(m => m.descricao === month.value)[0].id + 1).toString())
        }

        return {
            changeDate,
            months,
            month,
            years,
            year,
            value,
            _disabled
        }
    }
}
</script>

<style>

</style>
